<!--
 * @description: 通知弹框
 * @fileName: NoticeDialog.vue
 * @author: lili
 * @date: 2025-03-25
!-->
<template>
  <el-dialog :visible.sync="dialogVisible" width="50%" top="5vh" class="notice-dialog" :close-on-click-modal="false" @close="onClose">
    <div slot="title">
      <div class="notice-title">{{ noticeInfo.title }}</div>
      <div class="notice-time">{{ noticeInfo.createTime }}</div>
    </div>
    <el-scrollbar wrap-class="notice-scrollbar-wrap" style="height: calc(100vh - 10vh - 150px);">
      <div class="notice-content" v-html="noticeInfo.content"></div>
    </el-scrollbar>
    <div v-if="footer" class="flex-row justify-center" slot="footer">
      <el-button type="primary" style="width: 200px;" @click="onClose">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import DOMPurify from 'dompurify';

export default {
  name: 'NoticeDialog',
  props: {
    footer: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      noticeInfo: {},
    }
  },
  methods: {
    open(data) {
      this.dialogVisible = true
      this.noticeInfo = {
        ...data,
        content: DOMPurify.sanitize(data.content, { USE_PROFILES: { html: true } }) // 防止xss
      }
    },

    onClose() {
      this.dialogVisible = false
      this.$emit('close')
    }
  }
}
</script>

<style>
.notice-scrollbar-wrap {
  overflow-x: hidden !important;
}
</style>

<style lang='scss' scoped>
.notice-dialog {
  ::v-deep {
    .el-dialog__header {
      padding-bottom: 0;
    }

    .el-dialog__body {
      padding: 0;
    }
  }

  .notice-title {
    font-size: 20px;
    font-weight: 600;
    line-height: 30px;
    color: #000;
  }

  .notice-time {
    padding: 10px 0;
    border-bottom: 1px solid #f5f5f5;
    font-size: 12px;
    line-height: 20px;
    color: #999;
  }
}

// 重写默认Html标签样式
.notice-content ::v-deep {
  padding: 30px 20px;
  line-height: 1.15;

  h1 {
    font-size: 2em;
    margin-block-start: 0.67em;
    margin-block-end: 0.67em;
    font-weight: bold;
  }

  h2 {
    font-size: 1.5em;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    font-weight: bold;
  }

  h3 {
    font-size: 1.17em;
    margin-block-start: 1em;
    margin-block-end: 1em;
    font-weight: bold;
  }

  h4 {
    font-size: 1em;
    margin-block-start: 1.33em;
    margin-block-end: 1.33em;
    font-weight: bold;
  }

  h5 {
    font-size: 0.83em;
    margin-block-start: 1.67em;
    margin-block-end: 1.67em;
    font-weight: bold;
  }

  p {
    margin-block-start: 1em;
    margin-block-end: 1em;
  }

  ul {
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    padding-inline-start: 40px;
  }

  ol {
    list-style-type: decimal;
    margin-block-start: 1em;
    margin-block-end: 1em;
    padding-inline-start: 40px;
  }

  li {
    display: list-item;
    text-align: -webkit-match-parent;
  }

  a {
    color: -webkit-link;
    cursor: pointer;
    text-decoration: underline;
  }

  b,
  strong {
    font-weight: bold;
  }

  table {
    border: 1px solid #ccc;
  }

  /* 表格单元格（数据单元格） */
  td {
    min-height: 30px;
    height: 30px;
    padding: 3px 5px;
    border: 1px solid #ccc;
  }

  /* 表格单元格（表头单元格） */
  th {
    min-height: 30px;
    height: 30px;
    padding: 3px 5px;
    border: 1px solid #ccc;
    background-color: #f1f1f1;
    font-weight: bold;
    text-align: center;
  }
}
</style>
